import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { externalActions } from "./actions";
import { ExternalState } from "./types";

const initialState: ExternalState = {};

export function ExternalReducer(
  state = initialState,
  action: Action,
): ExternalState {
  if (isType(action, externalActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
